import { render, staticRenderFns } from "./MineTypeSelection.vue?vue&type=template&id=e603bbd4&scoped=true"
import script from "./MineTypeSelection.vue?vue&type=script&lang=js"
export * from "./MineTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./MineTypeSelection.vue?vue&type=style&index=0&id=e603bbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e603bbd4",
  null
  
)

export default component.exports